import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PAYROLL_FLAGGED_ENUMS, renderStaffName, SaveParams, staffStatusEnums } from 'utils';
import { DateTypeSelector, DownloadCsv, FilterPopover, SelectAutocompletePaginationMultiple, SelectTypeAutocomplete } from 'components';
import { adminActions } from 'store';
import { TIMESHEET_POPOVER_KEYS } from './timeSheetSelectedFilters';

export const ProcessedTimeSheetFilter = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const pushInfo = location?.state;

    useEffect(() => {
        dispatch(adminActions.getAdmins({ status: 'ACTIVE', sortType: 'fullName', orderType: 'ASC' }));
    }, []);
    const handleChange = (e) => {
        const newFilters = {
            ...pushInfo,
        };
        newFilters.skip = 0;
        newFilters.limit = 50;
        newFilters.page = 1;

        if (e?.target?.value === 'All') {
            delete newFilters[e.target.name];
        } else {
            newFilters[e.target.name] = e.target.value;
            if (e.target.name === 'staffs') {
                newFilters[e.target.name === 'staffs' ? 'staffFull' : ''] = e.target?.full;
            }
        }
        SaveParams(navigate, { ...newFilters });
    };

    const activeFiltersCount =
        (pushInfo?.staffs?.length ? 1 : 0) + (pushInfo?.flag ? 1 : 0) + (pushInfo?.start || pushInfo?.end ? 1 : 0);

    const handleResetAll = (handleClose) => {
        const params = { ...pushInfo, skip: 0, limit: 50, page: 1 };
        TIMESHEET_POPOVER_KEYS.forEach((k) => delete params[k]);
        SaveParams(navigate, params);
        handleClose?.();
    };

    return (
        <div className="payroll-filters-wrapper">
            <div className="filter-inputs-align-end">
                <FilterPopover activeFiltersCount={activeFiltersCount} onResetAll={handleResetAll}>
                    <SelectAutocompletePaginationMultiple
                        inputStyles={{width:'100%'}}
                        defaultStatuses={[staffStatusEnums.ACTIVE]}
                        outLabel={'Processor'}
                        uiType={'tableFilter'}
                        placeholder={
                            pushInfo?.staffFull?.length ? pushInfo?.staffFull?.map((i) => renderStaffName(i)).join(', ') : 'All'
                        }
                        name={'staffs'}
                        handleSelect={handleChange}
                        defaultValue={pushInfo?.staffFull ? pushInfo?.staffFull : []}
                        renderValue={(i) => renderStaffName(i)}
                        type={'staff'}
                        noError={true}
                    />
                    <SelectTypeAutocomplete
                        placeholder={pushInfo?.flag ? '' : 'All'}
                        name={'flag'}
                        outLabel={'Flag'}
                        handleSelect={handleChange}
                        defaultValue={pushInfo?.flag}
                        list={PAYROLL_FLAGGED_ENUMS}
                        renderValue={(i) => i?.label}
                        uiType={'tableFilter'}
                        noError={true}
                    />
                    <DateTypeSelector startName={'start'} endName={'end'} outLabel={'DOS'} />
                </FilterPopover>
                <DownloadCsv fromModal={true} type={'passivePayroll'} />
            </div>
        </div>
    );
};
